<template lang="pug"> 
v-row    
    v-col( cols="12" sm="12" md="12")
        v-simple-table(class="elevation-5" )
            thead(class="elevation-1"  )
                tr
                    th Editar
                    th Campo 
                    th Nombre  
                    th Estado   
                    th Validacion   
                    th Tipo                  
            draggable(:list="tablaInfo" tag="tbody" @change="eventoChange") 
                tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo")
                    td
                        button.btn.btn-sm.btn-info(@click="sendInfo(item)")  
                            i.fa.fa-edit 
                    td {{item.FieldType }}  
                    td {{item.FieldName}} 
                    td {{item.Active==1 ? 'Activo':'Inactivo'}} 
                    td {{item.IsValidated==1 ? 'SI':'NO'}} 
                    td {{item.Validate}} 
</template>
<script> 
import draggable from "vuedraggable";
export default {
    components:{draggable},
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    data(){
        return{
            parameters:{IdDocFiledTarget:-1,
                            IdDocFiled:-1}
        }
    },
    methods:{ 
            eventoChange(event){
                var _idDocField=event.moved.element.IdDocField
                var indexNew=(event.moved.newIndex+1)
                var indexOld=(event.moved.oldIndex+1)
                
                this.parameters.IdDocFiled=_idDocField

                if(indexNew<indexOld){
                    this.parameters.IdDocFiledTarget=this.tablaInfo[indexNew].IdDocField         
                }                    
                if(indexNew>indexOld){
                    this.parameters.IdDocFiledTarget=this.tablaInfo[indexNew-2].IdDocField
                }                
                 
                 this.$emit("changeOrder",this.parameters) 
            },
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            },
            sendInfoDinamic(item){  
             ///   this.$emit("sendInfoDinamic", Object.assign({}, item)) 
             this.$router.push({path:'/docConfig', query : { item: item }} )

            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>